import React from "react";

const LucidchartsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10.0072V30.0072L20.037 40V35.0108L7.25926 27.4982V12.5018L3 10.0072Z",
  fill: "#F96B13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.8147 12.5018V32.5017L37.074 30.0072V10.0072L32.8147 12.5018Z",
  fill: "#CC4E00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7778 2.49459L32.8149 12.5018L37.0741 10.0072L20.0371 0L15.7778 2.49459Z",
  fill: "#FFCA73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10.0072L7.25926 12.5018L11.5185 10.0072L7.25926 7.49817L3 10.0072Z",
  fill: "#FFCA73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25928 12.5018V27.4982L11.5185 25.0035V10.0072L7.25928 12.5018Z",
  fill: "#CC4E00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0371 35.0108V40L24.2964 37.5055V32.5018L20.0371 35.0108Z",
  fill: "#CC4E00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25928 27.4983L20.037 35.0109L24.2963 32.5018L11.5185 25.0036L7.25928 27.4983Z",
  fill: "#FFCA73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7778 2.49457V7.49816L28.5556 14.9964V30.0072L32.8149 32.5017V12.5018L15.7778 2.49457Z",
  fill: "#F96B13"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LucidchartsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;